module.exports = __webpack_public_path__ + "media/images/game_icon/en/AB1529-73fda32980d0b9efbc01a08c3fd8d0ca.png";